import React from 'react';
import { motion } from 'framer-motion';

/* Scroll-reveal wrapper: fades + rises children into view once. */
const Reveal = ({ children, delay = 0, y = 28, as = 'div', className, ...rest }) => {
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-80px' }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
      {...rest}
    >
      {children}
    </MotionTag>
  );
};

export default Reveal;
